import apiClient from './api';

export interface DashboardStats {
  totalItems: number;
  totalCategories: number;
  totalWarehouses: number;
  totalBranches: number;
  totalSuppliers: number;
  totalCustomers: number;
  totalPurchaseInvoices: number;
  totalAccounts: number;
  pendingPurchaseOrders: number;
  lowStockItems: number;
  todayPurchasesTotal: number;
  thisMonthPurchasesTotal: number;
  todayDailySalesTotal: number;
  thisMonthDailySalesTotal: number;
  yesterdayDailySalesTotal: number;
  lastMonthDailySalesTotal: number;
  openCustodies: number;
  custodiesBalance: number;
  draftJournalEntries: number;
}

export interface PurchasesChartData {
  date: string;
  dayName: string;
  purchasesTotal: number;
  purchasesCount: number;
  returnsTotal: number;
  returnsCount: number;
}

export interface SalesChartData {
  date: string;
  dayName: string;
  salesTotal: number;
  salesCount: number;
}

export interface BranchSales {
  branchId: number;
  branchName: string;
  branchNameAr: string;
  totalSales: number;
  salesCount: number;
}

export interface InventoryDistribution {
  categoryNameAr: string;
  categoryNameEn: string;
  itemCount: number;
  totalQuantity: number;
  percentage: number;
}

export interface RecentActivity {
  type: string;
  description: string;
  descriptionEn: string;
  amount: number | null;
  date: string;
  icon: string;
}

export interface LowStockItem {
  itemId: number;
  itemName: string;
  itemNameAr: string;
  currentStock: number;
  minStockLevel: number;
}

export interface DashboardAlert {
  type: string;
  title: string;
  titleEn: string;
  message: string;
  messageEn: string;
  count: number;
  items: LowStockItem[];
}

const dashboardService = {
  // جلب الإحصائيات الرئيسية
  getStats: async (): Promise<DashboardStats> => {
    const response = await apiClient.get('/Dashboard/stats');
    return response.data.data;
  },

  // جلب بيانات رسم المشتريات
  getPurchasesChart: async (days: number = 7): Promise<PurchasesChartData[]> => {
    const response = await apiClient.get(`/Dashboard/purchases-chart?days=${days}`);
    return response.data.data;
  },

  // جلب بيانات رسم المبيعات
  getSalesChart: async (days: number = 7): Promise<SalesChartData[]> => {
    const response = await apiClient.get(`/Dashboard/sales-chart?days=${days}`);
    return response.data.data;
  },

  // جلب مقارنة مبيعات الفروع
  getBranchSalesComparison: async (days: number = 30): Promise<BranchSales[]> => {
    const response = await apiClient.get(`/Dashboard/branch-sales-comparison?days=${days}`);
    return response.data.data;
  },

  // جلب توزيع المخزون
  getInventoryDistribution: async (): Promise<InventoryDistribution[]> => {
    const response = await apiClient.get('/Dashboard/inventory-distribution');
    return response.data.data;
  },

  // جلب النشاطات الأخيرة
  getRecentActivities: async (count: number = 10): Promise<RecentActivity[]> => {
    const response = await apiClient.get(`/Dashboard/recent-activities?count=${count}`);
    return response.data.data;
  },

  // جلب التنبيهات
  getAlerts: async (): Promise<DashboardAlert[]> => {
    const response = await apiClient.get('/Dashboard/alerts');
    return response.data.data;
  },
};

export default dashboardService;